import e from "../managers/braze-instance.js";
import ir from "./feature-flags-provider-factory.js";
import { getAllFeatureFlags } from "./get-all-feature-flags.js";
export function subscribeToFeatureFlagsUpdates(r) {
  if (!e.rr()) return;
  const t = getAllFeatureFlags();
  t && "function" == typeof r && r(t);
  return ir.er().ri(r);
}
